import { useMemo } from 'react';
import { useGetBatchTemplateChildrenQuery } from 'store/services/helios/templates';
import type { TemplateListItemRes } from 'types';
import { getHeliosAgendaIds, type ModuleLike } from 'utils/helios/getHeliosAgendaIds';
import type { HeliosTemplateChildrenContextValue } from 'contexts/HeliosTemplateChildrenContext';

export const useHeliosTemplateChildren = (modules?: ModuleLike[]): HeliosTemplateChildrenContextValue => {
  const heliosAgendaIds = useMemo(() => getHeliosAgendaIds(modules), [modules]);

  const { data: batchTemplateChildren, isLoading } = useGetBatchTemplateChildrenQuery(
    { templateIds: heliosAgendaIds },
    { skip: heliosAgendaIds.length === 0 }
  );

  const data = useMemo(() => {
    const map = new Map<string, TemplateListItemRes[]>();
    batchTemplateChildren?.items.forEach((item) => {
      map.set(item.templateId, item.children);
    });
    return map;
  }, [batchTemplateChildren]);

  return useMemo(() => ({ data, isLoading }), [data, isLoading]);
};
